import { Switch, Typography } from "@mui/material";
import { RULE_TYPE_OPTIONS } from "../data";

const ruleTypeLabel = (value) =>
  RULE_TYPE_OPTIONS.find((o) => o.value === value)?.label ?? value ?? "N/A";

export const getRuleColumns = ({ onEdit, onToggle, onDeactivate }) => [
  {
    accessorKey: "ruleType",
    header: () => "Rule Type",
    cell: ({ row }) => (
      <Typography fontSize="0.85rem" fontWeight={500}>
        {ruleTypeLabel(row.original.ruleType)}
      </Typography>
    ),
  },
  {
    accessorKey: "amountThreshold",
    header: () => "Threshold",
    cell: ({ row }) => (
      <Typography fontSize="0.85rem">{row.original.amountThreshold ?? "N/A"}</Typography>
    ),
  },
  {
    accessorKey: "startTime",
    header: () => "Window",
    cell: ({ row }) => (
      <Typography fontSize="0.82rem" color="text.secondary">
        {row.original.startTime && row.original.endTime
          ? `${row.original.startTime} – ${row.original.endTime}`
          : "N/A"}
      </Typography>
    ),
  },
  {
    accessorKey: "description",
    header: () => "Description",
    cell: ({ row }) => (
      <Typography fontSize="0.82rem" color="text.secondary">
        {row.original.description ?? "—"}
      </Typography>
    ),
  },
  {
    accessorKey: "isEnabled",
    header: () => "Enabled",
    cell: ({ row }) => (
      <Switch
        size="small"
        checked={Boolean(row.original.isEnabled)}
        onClick={(e) => e.stopPropagation()}
        onChange={() => onToggle?.(row.original)}
      />
    ),
  },
  {
    id: "actions",
    header: () => "Action",
    cell: ({ row }) => (
      <div style={{ display: "flex", gap: 12 }}>
        <Typography
          onClick={(e) => { e.stopPropagation(); onEdit?.(row.original); }}
          sx={{ fontSize: "0.82rem", fontWeight: 600, color: "primary.main", cursor: "pointer" }}
        >
          Edit
        </Typography>
        <Typography
          onClick={(e) => { e.stopPropagation(); onDeactivate?.(row.original); }}
          sx={{ fontSize: "0.82rem", fontWeight: 600, color: "error.main", cursor: "pointer" }}
        >
          Deactivate
        </Typography>
      </div>
    ),
  },
];